<ldw-truncated-text [text]="caption"></ldw-truncated-text>
